import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { div, sub } from "@thi.ng/vectors";
import { dispatch } from "../internal/dispatch";
export const mapPoint = defmulti(dispatch);
mapPoint.addAll({
    [Type.RECT]: ($, p, out = []) => div(null, sub(out, p, $.pos), $.size),
});
mapPoint.isa(Type.AABB, Type.RECT);
